import React from 'react';
import { motion } from 'framer-motion';
import { ShoppingBag, ArrowRight } from 'lucide-react';

export default function Store() {
  return (
    <main className="min-h-screen bg-secondary flex items-center justify-center px-6 py-24">
      <div className="max-w-4xl w-full text-center space-y-12">
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1.2 }}
          className="w-24 h-24 rounded-full bg-primary/5 flex items-center justify-center mx-auto mb-12"
        >
          <ShoppingBag className="w-10 h-10 text-accent" />
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.2 }}
        >
          <span className="text-[10px] font-bold tracking-[0.5em] uppercase text-accent mb-8 block">
            Coming Soon
          </span>
          <h1 className="text-5xl md:text-8xl font-serif mb-12 leading-tight">
            THE WALNUT <br />
            <span className="italic">COLLECTION.</span>
          </h1>
          <p className="text-lg md:text-2xl font-light text-primary/60 max-w-2xl mx-auto leading-relaxed italic">
            "A curated selection of estate-grown goods and handcrafted luxury essentials, arriving soon."
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, delay: 0.6 }}
          className="pt-16"
        >
          <a
            href="/"
            className="inline-flex items-center space-x-3 text-[10px] font-bold tracking-[0.3em] uppercase border-b border-primary/20 pb-4 hover:border-accent transition-colors group"
          >
            <span>Return to Estate</span>
            <ArrowRight className="w-3.5 h-3.5 group-hover:translate-x-1 transition-transform" />
          </a>
        </motion.div>
      </div>
    </main>
  );
}
